module.exports = "https://static.moomoo.com/components/common-redpacket/images/seq_0_0.396c0dfd56.png";